import Model, { attr } from '@warp-drive/legacy/model';
import { Type } from '@warp-drive/core-types/symbols';

/**
 * Auditor outcome record for a TAS audit worklist row (tio_tas.audit_logs),
 * sideloaded on the canonical detail read via
 * `GET /api/v2/audit-queues/:id?include=audit-logs` (Api::V2::AuditLogResource).
 *
 * Two entries tell the escalation story: the auditor's `audit` entry carries
 * their advisory opinion (correctAction/correctAmountCents + required
 * auditorNote), and the reviewer's `escalation_review` entry records the final
 * call. Rows are created only by the write actions, never from the client.
 */
export default class AuditLogModel extends Model {
  @attr declare auditQueueId: string;
  @attr declare actionType: 'audit' | 'escalation_review';
  @attr declare escalationRequested: boolean;
  @attr declare correctAction: 'approve_evidence' | 'reject_evidence' | 'decline_evidence' | null;
  @attr declare correctAmountCents: number | null;
  @attr declare correctResponse: string | null;
  @attr declare auditorNote: string | null;
  @attr declare employeeNote: string | null;
  @attr declare robotAmountOverpaidCents: number | null;
  @attr declare robotAmountUnderpaidCents: number | null;
  @attr declare personAmountOverpaidCents: number | null;
  @attr declare personAmountUnderpaidCents: number | null;
  @attr declare auditorName: string | null;
  @attr declare createdAt: string;
  @attr declare updatedAt: string;

  [Type] = 'audit-log' as const;
}
